import React from 'react';
/**
 * The Off Book mark = the Presence itself, miniaturized.
 * The icon and the soul of the app are the same object.
 * Use <OffBookMark/> alone on surfaces, or <OffBookLogo/> for the wordmark
 * where the Presence fills the "O".
 */
export function OffBookMark({ size = 18 }: {size?: number;}) {
  return (
    <span
      className="presence-mark inline-block align-middle"
      style={{
        width: size,
        height: size
      }}
      aria-hidden="true" />);


}
export function OffBookLogo({
  className = '',
  markSize = 17



}: {className?: string;markSize?: number;}) {
  return (
    <span
      className={`inline-flex items-center font-display uppercase tracking-[0.32em] text-gray-900 ${className}`}
      role="img"
      aria-label="Off Book">
      
      <span>Off&nbsp;Bo</span>
      <OffBookMark size={markSize} />
      <span className="ml-[0.18em]">k</span>
    </span>);

}